import { createSlice } from '@reduxjs/toolkit';
import { LOGOUT } from '../../../utils/constants';
import {
  editInfluencerExampleBuilder,
  fetchInfluencerExamplesBuilder,
  revertInfluencerExampleBuilder,
} from './builder';

const INIT_STATE = {
  fetchInfluencerExamplesInfo: {
    data: [],
    maxReached: false,
    pending: false,
    fetchMorePending: false,
  },
  pending: {
    revertInfluencerExample: false,
    editInfluencerExample: false,
  },
};

export const influencerExamplesSlice = createSlice({
  name: 'influencerExamples',
  initialState: INIT_STATE,
  reducers: {},
  extraReducers: builder => {
    fetchInfluencerExamplesBuilder(builder);
    editInfluencerExampleBuilder(builder);
    revertInfluencerExampleBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE }));
  },
});

export const selectFetchInfluencerExamplesInfo = state => state.influencerExamplesInfo.fetchInfluencerExamplesInfo;
export const selectInfluencerExamplesActionsPending = state => state.influencerExamplesInfo.pending;

export default influencerExamplesSlice.reducer;
